import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import { login } from "../../../api/login";
import { init } from "../../../helpers/api_helper";
import { toast } from 'react-toastify';
import { profileSuccess } from "../profile/actions";
import { procurementRoleTypes } from "../../../Components/constants/layout";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      );
      if (response) {
        yield put(loginSuccess(response));
        history('/dashboard')
      } else {
        yield put(apiError(response));
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(response));
      if (response) {
        yield put(loginSuccess(response));
        history('/dashboard')
      } else {
        yield put(apiError(response));
      }
    } else if (process.env.REACT_APP_API_URL) {

      const response = yield call(login, {
        email: user.email,
        password: user.password,
      });

       localStorage.setItem("authUser", JSON.stringify({ token: response.data.token }));
      

    // //  //sessionStorage.setItem("authUser", JSON.stringify({ token: response.data.token }));
     
     if (response.statusCode === 200) {
        yield put(loginSuccess(response));
        yield put(profileSuccess(response.data))

         if(response.data.procurementRoles.procurementRole.name === procurementRoleTypes.EXECUTIVE){
          history('/executive/dashboard')
         toast.success(response.message)
        }
        else if (response.data.procurementRoles.procurementRole.name === procurementRoleTypes.SALES_HEAD){
          history('/sales-head/dashboard')
          toast.success(response.message)

        }
        else if (response.data.procurementRoles.procurementRole.name === procurementRoleTypes.RSM){
          history('/RSM-dashboard')
          toast.success(response.message)

        } else if (response.data.procurementRoles.procurementRole.name === procurementRoleTypes.PURCHASE){
          history('/purchase-manager-dashboard')
          toast.success(response.message)

        } else if (response.data.procurementRoles.procurementRole.name === procurementRoleTypes.MANAGEMENT){
          history('/management-dashboard')
          toast.success(response.message)
        }
         init()

     } else {
     yield put(apiError(response));
     }
    }
  } catch (error) {
    console.log(error.message)
    toast.error(error.message)

    yield put(apiError(error.message));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      );
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history('/dashboard')
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
